/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengeDashboardSegmentStats } from './ChallengeDashboardSegmentStats';
import {
    ChallengeDashboardSegmentStatsFromJSON,
    ChallengeDashboardSegmentStatsFromJSONTyped,
    ChallengeDashboardSegmentStatsToJSON,
    ChallengeDashboardSegmentStatsToJSONTyped,
} from './ChallengeDashboardSegmentStats';

/**
 * 
 * @export
 * @interface ChallengeDashboardResponse
 */
export interface ChallengeDashboardResponse {
    /**
     * 
     * @type {string}
     * @memberof ChallengeDashboardResponse
     */
    challengeId: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeDashboardResponse
     */
    challengeName: string;
    /**
     * 
     * @type {number}
     * @memberof ChallengeDashboardResponse
     */
    totalParticipants: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeDashboardResponse
     */
    totalWithProgression: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeDashboardResponse
     */
    totalEntries?: number;
    /**
     * 
     * @type {Array<ChallengeDashboardSegmentStats>}
     * @memberof ChallengeDashboardResponse
     */
    segments: Array<ChallengeDashboardSegmentStats>;
    /**
     * 
     * @type {Date}
     * @memberof ChallengeDashboardResponse
     */
    generatedAt: Date;
}

/**
 * Check if a given object implements the ChallengeDashboardResponse interface.
 */
export function instanceOfChallengeDashboardResponse(value: object): value is ChallengeDashboardResponse {
    if (!('challengeId' in value) || value['challengeId'] === undefined) return false;
    if (!('challengeName' in value) || value['challengeName'] === undefined) return false;
    if (!('totalParticipants' in value) || value['totalParticipants'] === undefined) return false;
    if (!('totalWithProgression' in value) || value['totalWithProgression'] === undefined) return false;
    if (!('segments' in value) || value['segments'] === undefined) return false;
    if (!('generatedAt' in value) || value['generatedAt'] === undefined) return false;
    return true;
}

export function ChallengeDashboardResponseFromJSON(json: any): ChallengeDashboardResponse {
    return ChallengeDashboardResponseFromJSONTyped(json, false);
}

export function ChallengeDashboardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeDashboardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'challengeId': json['challengeId'],
        'challengeName': json['challengeName'],
        'totalParticipants': json['totalParticipants'],
        'totalWithProgression': json['totalWithProgression'],
        'totalEntries': json['totalEntries'] == null ? undefined : json['totalEntries'],
        'segments': ((json['segments'] as Array<any>).map(ChallengeDashboardSegmentStatsFromJSON)),
        'generatedAt': (new Date(json['generatedAt'])),
    };
}

export function ChallengeDashboardResponseToJSON(json: any): ChallengeDashboardResponse {
    return ChallengeDashboardResponseToJSONTyped(json, false);
}

export function ChallengeDashboardResponseToJSONTyped(value?: ChallengeDashboardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challengeId': value['challengeId'],
        'challengeName': value['challengeName'],
        'totalParticipants': value['totalParticipants'],
        'totalWithProgression': value['totalWithProgression'],
        'totalEntries': value['totalEntries'],
        'segments': ((value['segments'] as Array<any>).map(ChallengeDashboardSegmentStatsToJSON)),
        'generatedAt': ((value['generatedAt']).toISOString()),
    };
}

